export const EC_ITEMS_TAB_ID = "eClaims-Items";
export const EC_APPROVERS_TAB_ID = "eClaims-Approvers";
export const EC_ATTACHMENT_TAB_ID = "eClaims-Attachments";